<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw" :class="[post.photos.length ? 'fa-images' : 'fa-align-left', {'fas': active, 'far': !active}]"></i></template>
        <template v-slot:content>
            <div class="tile-title preview">{{ preview }}</div>
            <div class="meta"><i class="far fa-fw fa-user mr-2"></i>{{ post.author_name }}<b-tag size="is-small" class="ml-2" v-if="post.is_staff_post">Staff</b-tag></div>
            <div class="meta"><i class="far fa-fw fa-calendar-alt mr-2"></i>{{ post.created_at | moment('MMM Do, h:mma') }}</div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat" v-if="post.hidden"><i class="far fa-eye-slash" style="color:red"></i></span>
                <span class="stat" v-if="post.photos.length"><i class="far fa-images"></i>{{ post.photos.length }}</span>
                <span class="stat" v-if="post.reaction_count"><i class="far fa-heart"></i>{{ post.reaction_count }}</span>
                <span class="stat" v-if="post.comment_count"><i class="far fa-comment"></i>{{ post.comment_count }}</span>
            </div>
        </template>
        <template v-slot:details>
            <div class="details-rollout">
                <toolbar class="toolbar">
                    <b-tooltip label="Moderate">
                        <button class="icon-only" @click.stop="$emit('click')"><i class="far fa-gavel"></i></button>
                    </b-tooltip>
                    <b-tooltip :label="post.hidden ? 'Unhide' : 'Hide from group'">
                        <button class="icon-only" @click.stop="$emit('hide')"><i class="far" :class="post.hidden ? 'fa-eye' : 'fa-eye-slash'"></i></button>
                    </b-tooltip>
                    <b-tooltip label="Delete">
                        <button class="icon-only" @click.stop="$emit('delete')"><i class="far fa-trash-alt"></i></button>
                    </b-tooltip>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="ID">{{ post.id }}</data-row>
                    <data-row mini title="Created">{{ post.created_at | moment('MM/DD/YYYY h:mma') }}</data-row>
                    <data-row mini title="In Navigator">{{ post.hidden ? 'Hidden' : 'Everyone' }}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "../TIER/components/Toolbar";
    import DataRow from "../TIER/components/DataRow";
    import CardListItem from "../TIER/components/CardListItem";

    export default {
        name: 'WallPostListItem',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            post: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            preview: function () {
                return (this.post.body || '').replace(/\s+/g, ' ').trim() || '(photos only)';
            }
        }
    }
</script>

<style lang="scss" scoped>
    li {
        color: darken($t-primary, 10);

        .tile-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .preview {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 100%;
        }

        padding: 0.5rem 0;

        .details-rollout {
            margin-top: 0.5rem;
        }
    }
</style>
